<template>
  <div>
    <div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="模型类别">
          <el-radio-group v-model="form.resource">
            <el-radio v-for="(m) in modulesTypes" :key="m" :label="m"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="模型列表">
          <el-row style="max-height: 520px; overflow-y: auto">
            <el-col
              style="margin: 10px"
              :span="7"
              v-for="(o, index) in modulesList"
              :key="index"
              :offset="0"
            >
              <el-card :body-style="{ padding: '0px' }">
                <el-image
                  :preview-src-list="srcList"
                  style="height: 150px; width: 100%"
                  :src="o.image"
                  :fit="'fill'"
                ></el-image>
                <div style="padding: 0 16px">
                  <el-radio v-model="form.radio" :label="o">{{ o.name }}</el-radio>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div class="item-chaxun">
      <el-button @click="onSubmit" type="primary">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["subData"],
  data() {
    return {
      modulesTypes:ModulesTypes,
      form: {
        radio: "",
        resource: "",
      },
    };
  },
  computed: {
    srcList() {
      return this.modulesList.map((m) => m.image);
    },
    modulesList() {
      if (this.form.resource) {
        return ModulesLib[this.form.resource];
      }

      return [];
    },
  },
  created() {
    this.form.resource = this.subData;
  },
  methods: {
    onSubmit() {
      console.log(this.form);
      this.$bus.$emit("setModelUrl", this.form.radio);
      this.$parent.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.item-chaxun {
  display: flex;
  justify-content: center;
  align-items: center;
  position:absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
}
</style>
